import Box from '@mui/material/Box'

const ButtonLayoutDiv = ({children, className}) => {
    return (
        <Box
            className={className}
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                '& > *': { marginLeft: '20px' }
            }}
        >
            {children}
        </Box>
    )
}

export default ButtonLayoutDiv
